module.exports = __webpack_public_path__ + "static/Mzaalo_Logo-956ff6aa305163fdee26686231a2c979.png";